/* MSDI v1.13: fit the hover / extra images of product cards the same way the primary images are fitted (assets/msdi-cards-v113.css).
   The visible object of every extra image is measured (transparent / white margins ignored) and scaled to the size of the primary image's object,
   so a card does not change size when the picture changes on hover or swipe. Images that fill their whole frame (photos) and 3D media are left untouched.
   Measurements are cached in localStorage. Nothing is cropped or stretched and no media is changed. */
(function () {
  if (window.__msdiFit) return; window.__msdiFit = 1;
  var KEY = 'msdi_fit_v1', CACHE = {};
  try { CACHE = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) {}
  var saveT;
  function save() { clearTimeout(saveT); saveT = setTimeout(function () { try { localStorage.setItem(KEY, JSON.stringify(CACHE)); } catch (e) {} }, 800); }
  function fname(src) { var m = /\/files\/([^?]+)/.exec(src || ''); return m ? m[1] : null; }
  function sized(src, w) { src = src.indexOf('//') === 0 ? 'https:' + src : src; return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var pending = {};
  function measure(src) {
    var k = fname(src); if (!k) return Promise.resolve(null);
    if (CACHE[k]) return Promise.resolve(CACHE[k]);
    if (pending[k]) return pending[k];
    return (pending[k] = new Promise(function (res) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var W = 240, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
          var c = document.createElement('canvas'); c.width = W; c.height = H;
          var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0, W, H);
          var d = x.getImageData(0, 0, W, H).data, x0 = W, y0 = H, x1 = -1, y1 = -1;
          for (var y = 0; y < H; y++) for (var xx = 0; xx < W; xx++) {
            var i = (y * W + xx) * 4;
            if (d[i + 3] > 24 && !(d[i] > 240 && d[i + 1] > 240 && d[i + 2] > 240)) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (y < y0) y0 = y; if (y > y1) y1 = y; }
          }
          if (x1 < 0) return res(null);
          var r = { a: +(im.naturalWidth / im.naturalHeight).toFixed(3), x0: +(x0 / W).toFixed(3), y0: +(y0 / H).toFixed(3), x1: +((x1 + 1) / W).toFixed(3), y1: +((y1 + 1) / H).toFixed(3) };
          CACHE[k] = r; save(); res(r);
        } catch (e) { res(null); }
      };
      im.onerror = function () { res(null); };
      im.src = sized(src, 240);
    }));
  }
  /* object size and centre as fractions of a square frame (image shown with object-fit: contain) */
  function geom(b) {
    var dw = b.a >= 1 ? 1 : b.a, dh = b.a >= 1 ? 1 / b.a : 1;
    return { cw: (b.x1 - b.x0) * dw, ch: (b.y1 - b.y0) * dh, cx: .5 + ((b.x0 + b.x1) / 2 - .5) * dw, cy: .5 + ((b.y0 + b.y1) / 2 - .5) * dh };
  }
  function scaleOf(img) { var t = getComputedStyle(img).transform; if (!t || t === 'none') return 1; var m = /matrix\(([^)]+)\)/.exec(t); return m ? parseFloat(m[1].split(',')[0]) || 1 : 1; }
  function gallery(card) { return card.querySelector('.card-gallery'); }
  function imgs(g) { return Array.prototype.slice.call(g.querySelectorAll('slideshow-slide img, .product-media-container img')); }
  function fitCard(g, from, to) {
    var list = imgs(g); if (list.length < 2) return;
    var p = list[0], ps = p.currentSrc || p.getAttribute('src'); if (!fname(ps)) return;
    measure(ps).then(function (pb) {
      if (!pb) return;
      var pg = geom(pb), s1 = scaleOf(p), Th = pg.ch * s1, Tw = Math.max(pg.cw * s1, .5);
      list.slice(from, to).forEach(function (im) {
        if (im.__fit) return;
        var src = im.getAttribute('src') || im.currentSrc; if (!fname(src) || /\/preview_images\//.test(src)) { im.__fit = 1; return; }
        im.__fit = 1;
        measure(src).then(function (b) {
          if (!b) return;
          var g2 = geom(b);
          if (g2.cw * g2.ch > .62 && Th < .75) return; /* full-frame photo: leave as is */
          var s = Math.max(.5, Math.min(Th / g2.ch, Tw / g2.cw, 3.4));
          var tx = -(g2.cx - .5) * s * 100, ty = -(g2.cy - .5) * s * 100;
          im.style.transformOrigin = '50% 50%';
          im.style.transform = 'translate(' + tx.toFixed(1) + '%,' + ty.toFixed(1) + '%) scale(' + s.toFixed(2) + ')';
        });
      });
    });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting) return; io.unobserve(e.target); fitCard(e.target, 1, 3); });
  }, { rootMargin: '200px' }) : null;
  function seen(g) { if (g.__msdiFit) return; g.__msdiFit = 1; if (io) io.observe(g); else fitCard(g, 1, 3); }
  function scan() { Array.prototype.forEach.call(document.querySelectorAll('product-card .card-gallery'), seen); }
  /* the rest of a card's pictures (swipe / carousel) are fitted as soon as the card is used */
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var g = e.target && e.target.closest && e.target.closest('.card-gallery'); if (g) fitCard(g, 1, 99);
    }, { passive: true, capture: true });
  });
  var mo = 'MutationObserver' in window ? new MutationObserver(function () { clearTimeout(mo.t); mo.t = setTimeout(scan, 150); }) : null;
  function init() { scan(); if (mo) mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
